var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"mt-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","offset-xs1":""}},[_c('choose-appearance-constrain',{model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1),_c('v-flex',{attrs:{"xs12":""}},[(_vm.name)?_c('DataTable',{directives:[{name:"redirect-if-no-permission",rawName:"v-redirect-if-no-permission:SERVICES",arg:"SERVICES"}],attrs:{"url":_vm.api.ACTIONS.SERVICE_LOCATIONS(_vm.id),"descending":"","initial-url-search-params":_vm.params,"fields-hidden-main":[
        'radius',
        'polygon',
        'centroid',
        'deleted_at',
        'created_at',
        'updated_at',
        'type',
        'pivot',
        'landmark_type',
        'street_name',
        'street_number',
      ],"fields-hidden-add":[
        'id',
        'name',
        'radius',
        'polygon',
        'centroid',
        'deleted_at',
        'created_at',
        'updated_at',
        'type',
        'pivot',
      ],"titles":_vm.titles,"title":_vm.$t('settings.locations.attachedLocations', { name: _vm.name }),"enable-edit":false,"enable-delete":false,"fields-extra-add":_vm.fieldsExtraAdd,"force-reload":"","selected-actions":_vm.selectedActions,"selectable":'Select',"formatter":_vm.formatter,"delete-extra-data":{ type: _vm.type },"post-extra-data":{ type: _vm.type },"edit-extra-data":{ type: _vm.type }}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }